
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"882","height":"882","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_f_2388_23100)"}},[_c('circle',{attrs:{"cx":"441.012","cy":"441.011","r":"310.41","transform":"rotate(-4.23 441.012 441.011)","stroke":"#074570","stroke-opacity":".68","stroke-width":"100"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_f_2388_23100","x":".586","y":".585","width":"880.852","height":"880.854","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"40","result":"effect1_foregroundBlur_2388_23100"}})])])])
          )
        }
      }
    